export const THIRTY_SECONDS = 30 * 1000
export const MILLISECONDS_TO_SECONDS_DIVISER = 1000

/**
 * Token refresh tuning. See `tokenManager.shouldRefresh()`.
 */
// Refresh once ~80% of the token's lifetime has elapsed, i.e. when the remaining life drops
// below this share of the total lifetime.
export const REFRESH_REMAINING_LIFE_RATIO = 0.2
// Floor for the above, so a very short-lived token still gets refreshed with usable margin.
export const REFRESH_THRESHOLD_FLOOR_SECONDS = 30
// A proactive refresh is not attempted more often than this, so a client with a skewed clock
// cannot refresh on every single request.
export const REFRESH_MIN_INTERVAL_SECONDS = 30
// A refresh that has not settled by this point rejects its waiters rather than hanging the admin.
export const REFRESH_TIMEOUT_MS = 15 * 1000
// Cap on how long a follower waits for the leader tab to publish a new token.
export const REFRESH_LOCK_WAIT_MS = 10 * 1000
